import React from "react";
import { Construction } from "lucide-react";
import PageHeader from "./components/PageHeader";

export default function ComingSoon({ title, phase = "1.2" }) {
  return (
    <div data-testid={`crm-coming-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <PageHeader eyebrow={`Phase ${phase}`} title={title} subtitle="This module ships in the next sub-phase." />
      <div className="p-10">
        <div className="max-w-xl mx-auto text-center p-12 border border-dashed border-white/10 rounded-2xl">
          <Construction className="w-12 h-12 text-[#1F5EFF] mx-auto mb-6 opacity-60" />
          <h2 className="text-white text-xl mb-2">Coming in Phase {phase}</h2>
          <p className="text-white/50 text-sm">Backend endpoints and schema are already wired. UI arrives in the next release.</p>
        </div>
      </div>
    </div>
  );
}
